<template>
  <div
    class="solfigrtp-allin solfrgrallin"
    :class="[{ gw_loading: loading }]"
  >
    <div
      v-for="item in options"
      :key="item.id"
      class="solfrgrallin_item gw_hvr gw_loading_text"
      style="--weight: 700"
    >
      <div
        class="f-center"
        v-html="$t(`solfigr.sizes.advanced.${item.key}_before_input`)"
      />
      <NumberInput
        class="solfrgrallin_item_input"
        :class="`solfrgrallin_item_input_${item.key}`"
        :min="conf[item.key].min"
        :max="conf[item.key].max"
        :step="conf[item.key].step"
        :decimals="conf[item.key].decimals"
        :inputmode="conf[item.key].inputmode"
        :tabindex="inputTabIndex"
        :hasWheelScroll="false"
        :value="item.value"
        :data-tst="item.id"
        @input="value => handleInput({ value, item })"
      />
      <div
        class="f-center"
        v-html="$t(`solfigr.sizes.advanced.${item.key}_after_input`)"
      />
      <GwTooltip
        class="mr-1 gw_hvr_content my-auto ml-2"
        style="--hvr-content-opacity: 0.5"
        :tooltip="$t(`solfigr.sizes.advanced.${item.key}_tooltip`)"
      />
    </div>
  </div>
</template>

<script>
import GwTooltip from '@/components/lib/GwTooltip'
import NumberInput from '@/components/lib/NumberInput'
import { getSolfigrFields } from '@/store/solfigr/solfigr_helpers'

import format_mix from '@/mixins/format_mix'

export default {
  name: 'SolfigrSizesAllinSettings',
  components: {
    GwTooltip,
    NumberInput,
  },
  mixins: [format_mix],
  props: {
    allinTreshold: Number,
    allinIfLessThan: Number,
    mergeSizesThresholdPreflop: Number,
    mergeSizesThresholdFlop: Number,
    maxNumRaises: Number,
    isPreflop: Boolean,
    inputTabIndex: Number,
    loading: Boolean,
  },
  emits: ['update:allinsettings'],
  data() {
    this.conf = getSolfigrFields()
    return {}
  },
  methods: {
    handleInput({ value, item }) {
      if (item.value === value) return
      this.$emit('update:allinsettings', { value, key: item.id })
    },
  },
  computed: {
    options() {
      const res = [
        {
          id: 'slfrm_allin_threshold', //
          key: 'allin_threshold',
          value: this.allinTreshold,
        },
        {
          id: 'slfrm_allin_if_less_than', //
          key: 'allin_if_less_than',
          value: this.allinIfLessThan,
        },
        {
          id: 'slfrm_merge_sizes_threshold_preflop',
          key: 'merge_sizes_threshold',
          value: this.mergeSizesThresholdPreflop,
          hide: !this.isPreflop,
        },
        {
          id: 'slfrm_merge_sizes_threshold_flop',
          key: 'merge_sizes_threshold',
          value: this.mergeSizesThresholdFlop,
          hide: this.isPreflop,
        },
        {
          id: 'slfrm_max_num_raises',
          key: 'max_num_raises',
          value: this.maxNumRaises,
        },
      ].filter(({ hide }) => !hide)
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.solfrgrallin {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.25rem;
  background: var(--clr-black-1);
  border-radius: 4px;
  &_item {
    border-radius: 4px;
    color: var(--clr-grey-2);
    font-size: 0.875rem;
    display: flex;
    flex-wrap: wrap;
    &_input {
      border-radius: 4px;
      padding: 0.25rem;
      --input-width: 3rem;
      &_allin_if_less_than {
        --input-width: 4rem;
      }
    }
  }
}
</style>
